<mat-drawer-container class="container" autosize style="display: contents;" *ngIf="isNavEnable">
  <mat-drawer #drawer class="sidenav" mode="side" opened>
    <button
      mat-button
      class="menu-button"
      (click)="navigateToSTSadmin()"
      [routerLink]="['']"
    >
      <mat-icon>chevron_left</mat-icon>

      <span>Tilbage til STS Admin</span>
    </button>
    <mat-divider></mat-divider>

    <button
      *ngIf="isEnable('routes')"
      mat-button
      [ngStyle]="{ width: '100%' }"
      class="menu-button"
      routerLinkActive="active"
      [routerLink]="['routes']"
      (click)="navigateToRoute('routes')"
    >
      <span>Ruter</span>
    </button>

    <button
      *ngIf="isEnable('delegation')"
      mat-button
      [ngStyle]="{ width: '100%' }"
      class="menu-button"
      routerLinkActive="active"
      [routerLink]="['delegation']"
      (click)="navigateToRoute('delegation')"
    >
      <span>Delegering</span>
    </button>

    <button
      *ngIf="isEnable('administration')"
      mat-button
      [ngStyle]="{ width: '100%' }"
      class="menu-button"
      routerLinkActive="active"
      [routerLink]="['administration']"
      (click)="navigateToRoute('administration')"
    >
      <span>Administration</span>
    </button>
	
    <button
      *ngIf="isEnable('reports')"
      mat-button
      [ngStyle]="{ width: '100%' }"
      class="menu-button"
      routerLinkActive="active"
      [routerLink]="['reports']"
      (click)="navigateToRoute('reports')"
    >
      <span>Rapporter</span>
    </button>

  </mat-drawer>

  <div class="sidenav-content">
    <router-outlet></router-outlet>
  </div>
</mat-drawer-container>
